import Phaser from 'phaser';

export default class ShapePatternMaker {
  constructor() {
    this.usedPatterns = [];
    this.shapeNames = ['circle','triangle','star'];
  }

  getPattern (roundNum) {
    // create basic pattern, choose 2 shapes for levels up to 5, 2 or 3 for above,
    const patternItemNum = roundNum < 6 ? 2 : Phaser.Math.Between(2,3);
    const patternLength = roundNum < 6 ? Phaser.Math.Between(2,3) : Phaser.Math.Between(3,4);

    // select shapes to use
    const selectArray = [];
    while (selectArray.length < patternItemNum) {
      const randomShape = this.shapeNames[Phaser.Math.Between(0,this.shapeNames.length - 1)];
      if (selectArray.indexOf(randomShape) === -1) {
        selectArray.push(randomShape);
      }
    }

    // names for pattern sequence
    let patternString = '';// to check for duplicate types

    let patternShapes = selectArray.slice(0);
    patternShapes = Phaser.Utils.Array.Shuffle(patternShapes);

    // messy but need to add starting shapes to sequence string for duplicate check
    for (let s = 0; s < patternShapes.length; s++) {
      patternString += selectArray.indexOf(patternShapes[s]).toString();
    }
    while (patternShapes.length < patternLength) {
      const shapeIndex = Phaser.Math.Between(0,selectArray.length - 1);
      const addedShape = selectArray[shapeIndex];
      patternShapes.push(addedShape);
      patternString += shapeIndex.toString();
    }

    if (this.usedPatterns.indexOf(patternString) !== -1) {
      return this.getPattern(roundNum);
    }
    else {
      this.usedPatterns.push(patternString);

      // get full repeating pattern sequence
      const patternArray = [];
      let i = 1;
      let patternIndex = 0;
      while (i < 11) {
        const patternItemObj = { val: patternShapes[patternIndex], filled: true };
        patternArray.push(patternItemObj);
        patternIndex++;
        if (patternIndex > patternShapes.length - 1) patternIndex = 0;
        i++;
      }

      let spaces = roundNum;
      while (spaces > 0) {
        // remove random card
        const removeIndex = Phaser.Math.Between(0,patternArray.length - 1);
        if (patternArray[removeIndex].filled === true) {
          patternArray[removeIndex].filled = false;
          spaces--;
        }
      }

      const patternObj = { pattern: patternArray,sequence: patternString };
      return patternObj;
    }
  }

  replacePattern (sequence) {
    this.usedPatterns.splice(this.usedPatterns.indexOf(sequence),1);
  }
}